// Keep UI safe: React can't render plain objects as children.
export function getErrorMessage(err, fallback = '') {
  if (err == null) return fallback;

  if (typeof err === 'string') return err;
  if (Array.isArray(err)) {
    const parts = err
      .map((e) => getErrorMessage(e, ''))
      .map((s) => (typeof s === 'string' ? s.trim() : ''))
      .filter(Boolean);
    return parts.length ? parts.join('; ') : fallback;
  }
  if (typeof err === 'number' || typeof err === 'boolean' || typeof err === 'bigint') {
    return String(err);
  }

  // Native/Error-like objects
  if (err instanceof Error) return err.message || fallback;

  // Common API / validation error shapes
  if (typeof err === 'object') {
    const locPrefix =
      Array.isArray(err.loc) && err.loc.length > 0 ? `${err.loc.join('.')}: ` : '';

    let maybeMessage =
      err.message ||
      (typeof err.msg === 'string' ? `${locPrefix}${err.msg}` : undefined) ||
      err.detail ||
      err.error ||
      err.title ||
      (Array.isArray(err.errors) ? err.errors.join(', ') : undefined);

    if (typeof maybeMessage === 'string' && maybeMessage.trim() !== '') return maybeMessage;

    // Try a safe stringify (handles circular refs)
    try {
      const seen = new WeakSet();
      const json = JSON.stringify(
        err,
        (key, value) => {
          if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) return '[Circular]';
            seen.add(value);
          }
          if (typeof value === 'function') return '[Function]';
          return value;
        },
        2
      );
      // Avoid dumping huge payloads into the UI.
      return json.length > 1200 ? `${json.slice(0, 1200)}…` : json;
    } catch (e) {
      // Fall through
    }
  }

  return fallback || String(err);
}

